var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBagReturn = function SvgMoneyBagReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.762c-3.783 2.18-3.332 6.46-8.612 6.229-1.66-.072-3.102-.26-3.627-.563-1.233-.71-1.123-.814-1.69-1.997a5.65 5.65 0 0 1-.427-3.738c.29-1.255 1.005-3.257 2.054-4.162l3.69-3.332L7.78 3.025c.127-.164 1.72-.5 2.72 0s1.5-.5 2.5 0 2.673 0 2.673 0L13.602 7.2l2.898 2.61M8.646 7.2h6.697"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14h6v6"
  })));
};
export default SvgMoneyBagReturn;